import { cn } from './cn';

/**
 * The Svet mark: an ember tile with the ink S cut out of it.
 *
 * The colour order is the point, and it is D-02b. The logo orange is 2.04:1 on
 * cream, so an orange S on the console's paper would be a logo nobody can see —
 * and it is the exact mistake D-02b was written after. Inverting it puts the
 * orange where it belongs, underneath, with the ink S on top of it at 8.03:1.
 * The same arrangement is in public/favicon.svg, so the tab and the sidebar
 * agree.
 *
 * `size` is the tile's edge. The stroke scales with it, so the mark holds at
 * 20px in the sidebar and at 40px on the sign-in card.
 */
export function Wordmark({
  size = 24,
  withText = true,
  className,
}: {
  size?: number;
  withText?: boolean;
  className?: string;
}) {
  return (
    <span className={cn('inline-flex items-center gap-xs', className)}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        role="img"
        aria-label="Svet"
        className="shrink-0"
      >
        {/* The one sanctioned full-strength orange fill in the console. It is a
            SURFACE — the tile the ink S sits on at 8.03:1 — not a glyph, which
            is the distinction the lint rule cannot see from a class name alone.
            Every other `fill-sky-blue` in src/ is a mistake; hence the disable
            is one line wide and carries this reason. */}
        {/* eslint-disable-next-line no-restricted-syntax -- surface, not glyph: see above and D-02b */}
        <rect width="32" height="32" rx="7" className="fill-sky-blue" />
        <path
          d="M21 10.6a5.4 5.4 0 0 0-4.8-2.3c-3.1 0-5.1 1.7-5.1 4.1 0 2.3 1.7 3.3 4.6 4.1 3 .8 5.1 2 5.1 4.8 0 2.8-2.3 4.7-5.7 4.7a6.5 6.5 0 0 1-5.5-2.6"
          fill="none"
          strokeWidth={2.8}
          strokeLinecap="round"
          className="stroke-ink-navy"
        />
      </svg>
      {withText && (
        <span className="font-medium tracking-[-0.01em] text-ink-deep">Svet</span>
      )}
    </span>
  );
}
